


















































































































































































































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/Progress.scss";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

@Component({
  components: {
    apexchart: VueApexCharts,
    swiper,
    swiperSlide
  }
})
export default class Progress extends Vue {
  private service = new GeneralService();
  public subjectsObject: subjectModel[] = [];
  public subjectsVideoObject: subjectModel[] = [];
  private subjects: GActivity[] = [];
  private videoSubjects: GActivity[] = [];
  private items: GActivity[] = [];
  private activated: boolean = false;
  private level_id;
  private auth = new AuthService();
  private showAttendanceOption: boolean = false;
  private categories: string[] = [];
  private seriesData: any = [];
  private seriesVideoData: any = [];
  private seriesDataOld: any = [];
  private seriesVideoDataOld: any = [];
  private chartHeight: number = 200;
  private chartVideoHeight: number = 200;
  private dataAttempted: number[] = [];
  private chartNavigated = false;
  private chartVideoNavigated: number = -1;
  private chartVideoNavigatedVal = false;
  private personalInfo: any = { Name: "?", Campus: "?", Class: "?" };
  private attendance: any = {
    Monthh: "March",
    percentage: "99",
    TotalCount: 0,
    present: 0
  };
  private gotSubjects = false;
  private gotVideoSubjects = false;
  private timeTable: any = {
    Day: "Monday",
    Section: "CSS",
    TimeTableData: ["1"]
  };
  private timeTableJSON: any = [];
  private Fees: any = {
    Challan_Number: 0,
    Chalan_type_name: "1",
    Amount: "222",
    Due_date: "09/93/21",
    recieved_data: "09/03/12"
  };
  private Exams: any;
  private examDetail: any[] = [];
  private showTimeTable = false;
  private showFees = false;
  private showAttendance = true;
  private showExamsSection = false;
  private showTimeTableSection = false;
  private showExams = false;
  private showDetail = false;
  private selectedExam = "";
  private selectedMonth = false;
  private selectedMonthSelection = "";
  private path = "../assets/scripts/challan.xml";
  private isRoom = "";
  private isTeacher = "";
  private fields = [
    { key: "Subject", label: "Subject" },
    { key: "Obtained_Marks", label: "Marks Obtained" },
    { key: "TotalMarks", label: "Total Marks" },
    { key: "Remarks", label: "Remarks" }
  ];
  private subjSelected = false;
  private subjVideoSelected = false;

  swiperOption = {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true
    }
  };

  toggleNav(x) {
    this.showAttendance = false;
    this.showTimeTableSection = false;
    this.showFees = false;
    this.showExamsSection = false;
    this["show" + x] = true;
  }

  resetTimeTable() {
    let today = this.dayOfWeekAsString(new Date().getDay());
    this.timeTableJSON = [];
    let days: any = [];
    let daysData: any = [];
    if (this.timeTable[0].Status !== "902") {
      for (let day of this.timeTable) {
        let finalData: any = [];
        days.push(day.Day);
        for (let dataTable of day.TimeTableData) {
          let str = dataTable.ClassTime + "\n" + dataTable.SubjectName;
          if (this.isRoom === "checked") {
            str += "\n" + dataTable.Room;
          }

          if (this.isTeacher === "checked") {
            str += "\n" + dataTable.TeacherName;
          }

          finalData.push(str);
        }

        daysData.push(finalData);
      }

      for (let i = 0; i < daysData[0].length; i++) {
        let obj = {};
        for (let j = 0; j < days.length; j++) {
          obj[days[j]] = daysData[j][i];
          if (days[j] == today) {
            obj["_cellVariants"] = {};
            obj["_cellVariants"][days[j]] = "info";
          }
        }
        this.timeTableJSON.push(obj);
      }
    }
  }

  dayOfWeekAsString(dayIndex) {
    return [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ][dayIndex];
  }

  mounted() {
    this.$watch("isRoom", e => {
      this.resetTimeTable();
    });
    this.$watch("isTeacher", e => {
      this.resetTimeTable();
    });

    this.level_id = localStorage[config.classLevl];

    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }

    // this.service
    //   .getInfo(localStorage[config.username], localStorage[config.deviceId])
    //   .then(result => {
    //     this.personalInfo = result[0].Data[0];

    //     this.service
    //       .getAttendance(
    //         localStorage[config.username],
    //         localStorage[config.deviceId],
    //         this.personalInfo.Class_Level_ID
    //       )
    //       .then(result => {
    //         this.attendance = result[0].Data;
    //         if (this.attendance[0].Status !== "902") {
    //           this.showAttendanceOption = true;
    //         }
    //       });

    //     this.service
    //       .getTimeTable(
    //         localStorage[config.username],
    //       )
    //       .then(result => {
    //         let today = this.dayOfWeekAsString(new Date().getDay());
    //         this.timeTable = result[0].Data;
    //         let days: any = [];
    //         let daysData: any = [];
    //         if (this.timeTable[0].Status !== "902") {
    //           for (let day of this.timeTable) {
    //             let finalData: any = [];
    //             days.push(day.Day);
    //             for (let dataTable of day.TimeTableData) {
    //               let str = dataTable.ClassTime + "\n" + dataTable.SubjectName;
    //               if (this.isRoom) {
    //                 str += "\n" + dataTable.Room;
    //               }

    //               if (this.isTeacher) {
    //                 str += "\n" + dataTable.TeacherName;
    //               }

    //               finalData.push(str);
    //             }

    //             daysData.push(finalData);
    //           }

    //           for (let i = 0; i < daysData[0].length; i++) {
    //             let obj = {};
    //             for (let j = 0; j < days.length; j++) {
    //               obj[days[j]] = daysData[j][i];
    //               if (days[j] == today) {
    //                 obj["_cellVariants"] = {};
    //                 obj["_cellVariants"][days[j]] = "info";
    //               }
    //             }
    //             this.timeTableJSON.push(obj);
    //           }

    //           this.showTimeTable = true;
    //         }
    //       });

    //     this.service
    //       .getFeeChallan(
    //         localStorage[config.username],
    //         localStorage[config.deviceId],
    //         this.personalInfo.Class_Level_ID
    //       )
    //       .then(result => {
    //         this.Fees = result[0].Data;
    //       });

    //     this.service
    //       .getExams(
    //         localStorage[config.username],
    //         localStorage[config.deviceId],
    //         this.personalInfo.Class_Level_ID,
    //         this.personalInfo.Campus_id,
    //         this.personalInfo.Enrollment_ID
    //       )
    //       .then(result => {
    //         this.Exams = result[0].Data;
    //         if (this.Exams[0].Status !== "902") {
    //           this.showExams = true;
    //         }
    //       });
    //   });

    this.service
      .mcq_subject(this.level_id)
      .then(result => {
        this.subjects = result;
        this.gotSubjects = true;

        for (let subject of this.subjects) {
          this.service
            .chapters(subject.id)
            .then(result => {
              this.items = result;
              this.items.forEach(function(value) {
                if (
                  value.fullName.split(".")[1] !== undefined &&
                  value.fullName.split(".")[1] !== null &&
                  value.fullName.split(".")[1] !== ""
                ) {
                  value.fullName = value.fullName.split(".")[1];
                }
              });
              if (this.items.findIndex(e => e.fullName == "Promo") > -1) {
                this.items.splice(
                  this.items.findIndex(e => e.fullName == "Promo"),
                  1
                );

                let chapters: any = [];

                for (let item of this.items) {
                  chapters.push({ chapter: item, topics: [], watched: 0 });
                }

                this.subjectsObject.push({
                  subject: subject,
                  chapters: chapters
                });
                let total = 0;
                for (let chapter of this.items) {
                  total += chapter.maxWatched;
                }
                this.seriesData.push({
                  x: subject.fullName,
                  y: Math.ceil(total / this.items.length)
                });
                this.seriesDataOld = this.seriesData;
              }
            })
            .catch(err => {
              console.error(`Error: ${err.message}`);
            });
        }
      })
      .catch(err => {
        console.error(`Error: ${err.message}`);
      });

    this.service.subjects(this.level_id).then(result => {
      this.videoSubjects = result;
      this.gotVideoSubjects = true;
      for (let subject of this.videoSubjects) {
        this.populateVideoObject(subject);
      }
    });
  }

  series = [
    {
      name: "Attempted Correctly",
      data: this.seriesData
    }
  ];

  videoSeries = [
    {
      name: "Watched",
      data: this.seriesVideoData
    }
  ];

  async populateVideoObject(subject) {
    this.service
      .chapters(subject.id)
      .then(result => {
        this.items = result;
        this.items.forEach(function(value) {
          if (
            value.fullName.split(".")[1] !== undefined &&
            value.fullName.split(".")[1] !== null &&
            value.fullName.split(".")[1] !== ""
          ) {
            value.fullName = value.fullName.split(".")[1];
          }
        });

        if (this.items.findIndex(e => e.fullName == "Promo") > -1) {
          this.items.splice(
            this.items.findIndex(e => e.fullName == "Promo"),
            1
          );
        }
        let chapter: any = [];
        for (let item of this.items) {
          this.service
            .topics(item.id)
            .then(result => {
              let watching = 0;

              var watched = 0;
              for (var topic of result) {
                watched += topic.maxWatched;
              }

              watching = Math.round(
                (watched / (this.items.length * 100)) * 100
              );
              chapter.push({
                chapter: item,
                topics: result,
                watched: watching
              });
            })
            .catch(err => {
              console.error(`Error: ${err.message}`);
            });
        }

        this.subjectsVideoObject.push({ subject: subject, chapters: chapter });
        this.seriesVideoData.push({
          x: subject.fullName,
          y: subject.maxWatched
        });
        this.seriesVideoDataOld = this.seriesVideoData;
      })
      .catch(err => {
        console.error(`Error: ${err.message}`);
      });
  }

  subjectSelected(event, chartContext, config) {
    this.subjSelected = true;
    const items = this.subjectsObject[config.dataPointIndex];
    if (items && !this.chartNavigated) {
      this.seriesData = [];
      for (let item of items.chapters) {
        this.seriesData.push({
          x: item.chapter.fullName,
          y: Math.min(Math.ceil(item.chapter.maxWatched), 100)
        });
      }

      (this.$refs.chart as any).updateSeries([
        {
          name: "Attempted Correctly",
          data: this.seriesData
        }
      ]);
    }

    this.chartNavigated = true;

    this.chartHeight = 50 * this.seriesData.length;

    this.series = [
      {
        name: "Attempted Correctly",
        data: this.seriesData
      }
    ];

    (this.$refs.chart as any).render();
  }

  subjectVideoSelected(event, chartContext, config) {
    this.subjVideoSelected = true;

    if (!this.chartVideoNavigatedVal) {
      let items;
      let changeVal = false;
      if (this.chartVideoNavigated == -1) {
        items = this.subjectsVideoObject[config.dataPointIndex];
      } else {
        items = this.subjectsVideoObject[this.chartVideoNavigated].chapters[
          config.dataPointIndex
        ];
        changeVal = true;
      }

      if (items && this.chartVideoNavigated == -1) {
        this.seriesVideoData = [];
        for (let item of items.chapters) {
          let watched = 0;
          for (let topic of item.topics) {
            watched += topic.maxWatched;
          }

          watched = Math.round((watched / (item.topics.length * 100)) * 100);

          this.seriesVideoData.push({
            x: item.chapter.fullName,
            y: Math.min(Math.ceil(watched), 100)
          });
        }
      } else if (items) {
        this.seriesVideoData = [];
        for (let item of items.topics) {
          this.seriesVideoData.push({
            x: item.fullName,
            y: Math.ceil(item.maxWatched)
          });
        }
      }

      (this.$refs.chart2 as any).updateSeries([
        {
          name: "Watched",
          data: this.seriesVideoData
        }
      ]);

      this.chartVideoNavigated = config.dataPointIndex;
      this.chartVideoNavigatedVal = changeVal;

      this.chartVideoHeight = 50 * this.seriesVideoData.length;

      this.videoSeries = [
        {
          name: "Watched",
          data: this.seriesVideoData
        }
      ];

      (this.$refs.chart2 as any).render();
    }
  }

  revertSubjectSelected() {
    (this.$refs.chart as any).updateSeries([
      {
        name: "Attempted Correctly",
        data: this.seriesDataOld
      }
    ]);

    this.series = [
      {
        name: "Attempted Correctly",
        data: this.seriesDataOld
      }
    ];
    this.chartNavigated = true;

    this.chartHeight = 70 * this.seriesDataOld.length;

    (this.$refs.chart as any).render();
  }

  revertSubjectSelectedVideo() {
    (this.$refs.chart2 as any).updateSeries([
      {
        name: "Watched",
        data: this.seriesVideoDataOld
      }
    ]);

    this.chartVideoNavigatedVal = false;
    this.chartVideoNavigated = -1;

    this.chartVideoHeight = 70 * this.seriesVideoDataOld.length;

    this.videoSeries = [
      {
        name: "Watched",
        data: this.seriesVideoDataOld
      }
    ];

    (this.$refs.chart2 as any).render();
  }

  examSelected(evt) {
    this.service
      .getExamDetail(
        localStorage[config.username],
        localStorage[config.deviceId],
        evt.target.value
      )
      .then(result => {
        this.examDetail = result[0].Data;
        this.showDetail = true;
        if (this.examDetail[0].OverAllGrade.trim() !== "F") {
          this.examDetail.push({
            Subject: "Total",
            Obtained_Marks: this.examDetail[0].OAllObtMarks,
            TotalMarks: this.examDetail[0].OAllTotMarks,
            Remarks: this.examDetail[0].OverAllGrade,
            _rowVariant: "success"
          });
        } else {
          this.examDetail.push({
            Subject: "Total",
            Obtained_Marks: this.examDetail[0].OAllObtMarks,
            TotalMarks: this.examDetail[0].OAllTotMarks,
            Remarks: this.examDetail[0].OverAllGrade,
            _rowVariant: "danger"
          });
        }
      });
  }

  monthSelected(evt) {
    this.selectedMonth = true;
  }

  chartOptions = {
    colors: ["#e74c3c"],
    chart: {
      events: {
        dataPointSelection: this.subjectSelected
      }
    },
    dataLabels: {
      style: {
        colors: ["white"]
      },
      formatter: function(val) {
        if (val !== 0) {
          return val;
        } else {
          return "";
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {
      max: 100,
      style: {
        color: "white"
      },
      labels: {
        style: {
          color: "white"
        }
      }
    },
    tooltip: {
      color: "red",
      intersect: true,
      shared: false,
      y: {
        formatter: function(val) {
          return val + "%";
        }
      },

      x: {
        formatter: function(val) {
          return val;
        }
      }
    },

    yaxis: {
      labels: {
        formatter: function(val, index) {
          return val;
        },
        style: {
          color: "white",
          fontSize: "16px"
        }
      },
      max: 100,
      min: 0
    },
    axisBorder: {
      height: 3
    },
    markers: {
      size: 4
    }
  };

  chartVideoOptions = {
    colors: ["#e74c3c"],
    chart: {
      events: {
        dataPointSelection: this.subjectVideoSelected
      }
    },
    dataLabels: {
      style: {
        colors: ["white"]
      },
      formatter: function(val) {
        if (val !== 0) {
          return val;
        } else {
          return "";
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {
      max: 100,
      style: {
        color: "white"
      },
      labels: {
        style: {
          color: "white"
        }
      }
    },
    tooltip: {
      intersect: true,
      shared: false,
      y: {
        formatter: function(val) {
          return val + "%";
        }
      },

      x: {
        formatter: function(val) {
          return val;
        }
      }
    },

    yaxis: {
      labels: {
        formatter: function(val, index) {
          return val;
        },
        style: {
          color: "white",
          fontSize: "16px"
        }
      },
      max: 100,
      min: 0
    },
    axisBorder: {
      height: 3
    },
    markers: {
      size: 4
    }
  };
}

interface subjectModel {
  subject: GActivity;
  chapters: chapterModel[];
}

interface chapterModel {
  chapter: GActivity;
  topics: GActivity[];
  watched: number;
}
